// 關於我們 社群連結
'use client';

import Image from 'next/image';
import { CRYPTO_CITY_OFFICIAL_URL } from '@/common/constant';

const links = [
    { link: CRYPTO_CITY_OFFICIAL_URL.FB, name: 'facebook' },
    { link: CRYPTO_CITY_OFFICIAL_URL.TELEGRAM, name: 'telegram' },
    { link: CRYPTO_CITY_OFFICIAL_URL.TWITTER, name: 'twitter' },
    { link: CRYPTO_CITY_OFFICIAL_URL.LINE, name: 'line' },
    { link: CRYPTO_CITY_OFFICIAL_URL.IG, name: 'instagram' },
];

const AboutSocial = () => {
    return (
        <div className="flex center-center mx-auto gap-x-[20px] [&>*]:w-[30px] [&>*]:h-[30px] [&>*]:img-box [&>*]:after:content-none [&>a]:trans">
            {links.map((l, i) => (
                <a
                    key={l?.link + i}
                    href={l?.link}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="hover:scale-[1.1]"
                >
                    <Image
                        width={30}
                        height={30}
                        src={`/images/column/icon_${l?.name}.svg`}
                        alt={l?.name}
                    />
                </a>
            ))}
        </div>
    );
};

export default AboutSocial;
